import React from "react";

function Menu({data, selected, onClickSelect}) {
  return (
      <div class="p-5 cursor-pointer">
        {
            data.map((dataObj, index)=>{
                    return (
                        <div className={`${index === 4 && `pt-5 mt-5 `} ${index === 0 && 'border-bottom border-gray-200 dark-border-dark-5 '}  `} onClick={()=>onClickSelect(dataObj.id)}>
                                <a
                                className={`d-flex align-items-center mt-5 ${selected === dataObj.id && `text-theme-1 dark-text-theme-10 fw-medium`}`}
                            >
                            <div className="p-1">{dataObj.icon}</div>{' '}<div className="p-1">{dataObj.menuLabel}</div>
                            </a>
                        </div>
                        
                    )
               
            })
        }
    </div>
  );
}

export default Menu;
